import $ from 'jquery';

$('.timeline__filter-item').on('click', function () {
    $(this).siblings().removeClass('timeline__filter-item--active')
    $(this).addClass('timeline__filter-item--active')
    var sortDirection = $(this).data('sort');
    var $timeline = $(this).closest('.timeline');

    var hiddenCount = $timeline.find('.timeline__item--hidden').length
    var timelineLength = $('.timeline__item').length;

    $timeline.find('.timeline__item').removeClass('timeline__item--hidden');

    if(sortDirection === 'old') {
        var i = timelineLength;
        $timeline.find('.timeline__item').each(function () {
            $(this).css('order',i);
            i--;
        })
        $timeline.addClass('timeline--reversed');
        $timeline.find('.timeline__item').slice(0,hiddenCount).addClass('timeline__item--hidden')
    } else {
        $timeline.removeClass('timeline--reversed');
        $timeline.find('.timeline__item').removeAttr('style');
        if(hiddenCount > 0) {
            $timeline.find('.timeline__item').slice(0 - hiddenCount).addClass('timeline__item--hidden')
        }
    }
})

$('.timeline__load-more-button').on('click',function () {
    var $timeline = $(this).closest('.timeline');
    if($timeline.hasClass('timeline--reversed')) {
        $timeline.find('.timeline__item--hidden').slice(-6).removeClass('timeline__item--hidden');
    } else {
        $timeline.find('.timeline__item--hidden').slice(0,6).removeClass('timeline__item--hidden');
    }

    if($timeline.find('.timeline__item--hidden').length === 0) {
        $(this).parent('.timeline__load-more-wrap').remove();
    }
})
